import { Cushion, FlexContainer, Rectangle, Shadow, Typography } from '@pitchero/react-ui';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Icon from '../icon';
import { withTranslation } from '../../lib/i18n';

const CommentForm = ({ inputRef, isReply, isSubmitting, onSubmit, t }) => {
  const [text, setText] = useState('');
  const canSubmit = text.length > 0 && !isSubmitting;

  const submit = () => {
    if (canSubmit) {
      onSubmit(text);
      setText('');
    }
  };

  const onKeyPressHandler = (event) => {
    const key = event.key || event.keyCode;
    if ((key === 'Enter' || key === 13) && event.shiftKey === false) {
      event.preventDefault();
      submit();
    }
  };

  return (
    <Cushion vertical="small" component="div">
      <Shadow shadow={isReply ? 'none' : 'message'}>
        <Rectangle fill={isReply ? 'seashellgrey' : 'white'} radius={21}>
          <Cushion all="small">
            <FlexContainer justifyContent="space-between" alignItems="flex-end">
              <Typography
                preset="body--small"
                style={{
                  alignSelf: 'center',
                  flexGrow: 1,
                }}
                color="black"
                component="div"
              >
                <textarea
                  disabled={isSubmitting}
                  ref={inputRef}
                  value={text}
                  rows={3}
                  placeholder={t('common:comment_field_placeholder')}
                  onChange={(event) => setText(event.target.value)}
                  onKeyDown={(e) => {
                    onKeyPressHandler(e);
                  }}
                  style={{
                    backgroundColor: isReply ? '#f1f1f1' : 'white',
                    border: 'none',
                    outline: 'none',
                    width: '100%',
                    padding: 0,
                    display: 'block',
                    resize: 'none',
                  }}
                />
              </Typography>
              <Icon
                name="send"
                color={canSubmit ? 'primary' : 'dustygrey'}
                size={22}
                onClick={submit}
              />
            </FlexContainer>
          </Cushion>
        </Rectangle>
      </Shadow>
    </Cushion>
  );
};

CommentForm.defaultProps = {
  inputRef: null,
  isReply: false,
  isSubmitting: false,
};

CommentForm.propTypes = {
  inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape()]),
  isReply: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};
export default withTranslation(['common'])(CommentForm);
